import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { SelectionDialogComponent } from './selection-dialog.component';



@NgModule({
  declarations: [
    SelectionDialogComponent
  ],
  exports: [
    SelectionDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ]
})
export class SelectionDialogModule { }
